import {
  CUSTOMIZATION,
  JUMPER,
  MATCH_3,
  MEMORIES,
  PLATFORM,
  PROCEDURE_GAME,
} from '../../../../constants/shared/states/names'

export const getProductCurrentState = (state, filter) => {
  const isGameState = [MATCH_3, JUMPER, PLATFORM, MEMORIES].includes(state)
  const isBeautyRoutineState = [PROCEDURE_GAME].includes(state)
  const isCustomizationState = [CUSTOMIZATION].includes(state)

  const gameNames = {
    [MATCH_3]: 'Три в ряд',
    [JUMPER]: 'Прыжки',
    [PLATFORM]: 'Бьютипад',
    [MEMORIES]: 'Найди пару',
  }

  const gameName = isGameState ? gameNames[state] : null

  const customizationFilterNames = {
    room: 'Комната',
    character: 'Гардероб',
    shower: 'Ванная',
  }

  const customizationFilterName = isCustomizationState ? customizationFilterNames[filter] : null

  return {
    isGameState,
    gameName,
    isBeautyRoutineState,
    isCustomizationState,
    customizationFilterName,
  }
}
